// extracted by mini-css-extract-plugin
export default {"maincontainer":"Analytics_maincontainer__saGrz","section":"Analytics_section__Ql6z3","priority":"Analytics_priority__ULb41"};